import React from 'react';
import { EventType } from '../../CalendarTypes';
import { ContentHeadline } from '../../../../_lib/components/ContentHeadline';
import { ContentLink } from '../../../../_lib/components/ContentLink';
import { CategoryLabel } from '../../../../_lib/components/CategoryLabel';

type CalendarEventListType = {
  eventListId: string;
  eventsToShow: EventType[];
  parseSelectedDate: (dateOfEvent: string) => string;
};

export function CalendarEventList({ eventListId, eventsToShow, parseSelectedDate }: CalendarEventListType) {
  return (
    <div className="calendar__event-list-container" id={eventListId}>
      {eventsToShow.length > 0 && (
        <>
          <ContentHeadline title={parseSelectedDate(eventsToShow[0].date)} hierarchy={3} />
          <ol className="calendar__event-list">
            {eventsToShow.map((eventItem: EventType) => (
              <li
                key={eventItem.url}
                className="calendar__event-list-item"
                style={
                  eventItem.categories && eventItem.categories.length > 0
                    ? { borderColor: eventItem.categories[0].hexColor }
                    : undefined
                }
              >
                <CategoryLabel
                  className="calendar__event-category font-regular-13-13"
                  categories={eventItem.categories}
                />
                {eventItem.url && <ContentLink to={eventItem.url}>{eventItem.title}</ContentLink>}
              </li>
            ))}
          </ol>
        </>
      )}
    </div>
  );
}
